module.exports = __webpack_public_path__ + "static/img/Francis-Molo.62806f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Francis-Molo.jpg
// module id = Yv32
// module chunks = 0